/** @jsx jsx */
import React, { useContext, useState, useCallback } from 'react'
import { getEnvConfig, getPermitActions, getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { rowHeaderRender, hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { jsx } from '@emotion/core'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
} from '@integec/grid-tools'
import { dateCol, numCol, strCol, intCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { Button, DatePicker, Input, Tabs, Upload, Icon, message } from 'antd'
import { getSwitchBoardONS, getAuthorization, getCredentials } from 'api/pgads'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import qs from 'querystring'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const ONS = ({ envConfig, actionPermits, apiTargetInfo }) => {
  const { authGodMode } = envConfig

  // eslint-disable-next-line no-unused-vars
  const importPermisiion = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.SWITCHBOARD_IMPORT],
    matchAny: true,
  })
  const [importResult, setImportReult] = useState([])
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [dataONS, setDataONS] = useState({
    detailData: [],
    metaData: [],
    statusData: [],
  })
  const [fuzzyFilter, setFuzzyFilter] = useState([])
  const retrieve = ({ date = selectedDate }) => {
    setSpinning(true)
    getSwitchBoardONS(apiTargetInfo)(date).fork(setError, data => {
      setDataONS(data)
      setSpinning(false)
    })
  }

  const cellRender = props => {
    const { gridToolProps, reactVirtualizedProps } = props
    const { getCellProps, headers, data } = gridToolProps
    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const { station, unit, transdate, transhour } = data[rowIndex]

    const cellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })

    const statusData =
      (dataONS.statusData || []).find(
        f =>
          f.station === station &&
          f.unit === unit &&
          f.transdate === transdate &&
          f.transhour === transhour
      ) || {}
    const headerIdent = headers[columnIndex].ident
    const statusValue = statusData[headerIdent]

    // const style = reactVirtualizedProps.style
    return defaultVirtualizedCellRender({
      ...props,
      style: {
        ...style,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        borderTop: '1px solid #cc',
        backgroundColor:
          statusValue === 'E'
            ? 'yellow'
            : cellProps.isSelected
            ? '#F8F8F8'
            : 'white',
        color: cellProps.isSelected ? 'black' : undefined,
      },
    })
  }

  const url = ft =>
    `${apiTargetInfo.baseUrl}/switchboard/import-ons?${qs.stringify({
      fileType: ft,
    })}`
  const fileProps = {
    name: 'file',
    action: url('ons'),
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const onFileUploadChange = useCallback(
    info => {
      if (info.file.status === 'done') {
        setSpinning(false)
        message.success(`${info.file.name} file uploaded successfully`)
        // setImportResponse(info.file.response)
        // message.info(info.file.response)
        setImportReult(info.file.response)
        // retrieveData()
      } else if (info.file.status === 'error') {
        setSpinning(false)
        // reportError(info.file.response)
        // onError(info)
        setError(info.file.response)
        if (info.file.response.appExceptionId !== 100)
          message.error(`${info.file.name} file have invalid data`)
      }
    },
    [setError, setSpinning]
  )

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <JcTmpErrorDialog
        visible={importResult.length > 0}
        errors={importResult}
        closeErrorPrompt={_ => setImportReult([])}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '250px',
          }}
        >
          ONS
        </Title>
        <DatePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            if (d && d.isValid) {
              setSelectedDate(d)
              retrieve({ date: d })
            }
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={_ => retrieve({ date: selectedDate })}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>
        <Filler />

        {importPermisiion && (
          <Upload
            {...fileProps}
            onChange={data => {
              setSpinning(true)
              onFileUploadChange(data)
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button>
              <Icon type="upload" /> Import
            </Button>
          </Upload>
        )}

        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={240}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Tabs type="card">
              <Tabs.TabPane tab="Metadata" key="metadata">
                <div css={{ minWidth: '500px', minHeight: '500px' }}>
                  <Grid
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled={false}
                    data={dataONS.metaData}
                    headers={IfSwbdOnsMHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 150,
                      headerRowHeight: 30,
                    })}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Detail data" key="detaildata">
                <div css={{ minWidth: '500px', minHeight: '500px' }}>
                  <Grid
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled={false}
                    data={dataONS.detailData}
                    headers={IfSwbdOnsUDHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 50,
                      headerRowHeight: 30,
                      cellRender,
                    })}
                    sortOptions={[
                      {
                        ident: 'station',
                        display: 'Station',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'transdate',
                        display: 'Transdate',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'transhour',
                        display: 'Transhour',
                        isKey: true,
                        sortOrder: 'asc',
                      },

                      {
                        ident: 'unit',
                        display: 'Unit',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                    ]}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  apiTargetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(ONS)

const IfSwbdOnsMHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  strCol({
    ident: 'netGenEquation',
    display: 'Net Gen Equation',
    width: 700,
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
]

/* const IfSwbdOnsMHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  numCol({ ident: 'transhour', display: 'Transhour', isKey: true }),
  numCol({ ident: 'stationNet', display: 'Station Net', isFiltered: true }),
  numCol({
    ident: 'standby13Meter',
    display: 'Standby 13 Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'standby13Diff',
    display: 'Standby 13 Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'standby100Meter',
    display: 'Standby 100 Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'standby100Diff',
    display: 'Standby 100 Diff',
    isFiltered: true,
  }),
] */

const IfSwbdOnsUDHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  intCol({ ident: 'transhour', display: 'Transhour', isKey: true }),
  numCol({ ident: 'stationNet', display: 'Station Net', isFiltered: true }),
  numCol({
    ident: 'standby13Meter',
    display: 'Standby 13 Meter',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'standby13Diff',
    display: 'Standby 13 Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'standby100Meter',
    display: 'Standby 100 Meter',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'standby100Diff',
    display: 'Standby 100 Diff',
    isFiltered: true,
  }),
  numCol({ ident: 'unitNet', display: 'Unit Net', isFiltered: true }),
  numCol({
    ident: 'grossMwhMeter',
    display: 'Gross MWH Meter',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'grossMwhDiff',
    display: 'Gross MWH Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'auxTransTMeter',
    display: 'Aux Trans T Meter',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'auxTransTDiff',
    display: 'Aux Trans T Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'suTransCtMeter',
    display: 'SU Trans CT Meter',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'suTransCtDiff',
    display: 'SU Trans CT Diff',
    isFiltered: true,
  }),
  numCol({ ident: 'fiveTMeter', display: 'Five T Meter', isFiltered: true }),
  numCol({ ident: 'fiveTDiff', display: 'Five T Diff', isFiltered: true }),
  numCol({ ident: 'fourTMeter', display: 'Four T Meter', isFiltered: true }),
  numCol({ ident: 'fourTDiff', display: 'Four T Diff', isFiltered: true }),
  numCol({ ident: 'ssfdMeter', display: 'SSFD Meter', isFiltered: true }),
  numCol({ ident: 'ssfdDiff', display: 'SSFD Diff', isFiltered: true }),
  numCol({ ident: 'totalGross', display: 'Total Gross', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
].map(d =>
  d.type === 'num' && d.ident !== 'transhour'
    ? { ...d, displayFormat: '000,000,000.00' }
    : d
)

/* const IfSwbdOnsSHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  numCol({ ident: 'transhour', display: 'Transhour', isKey: true }),
  strCol({ ident: 'stationNet', display: 'StationNet', isFiltered: true }),
  strCol({
    ident: 'standby13Meter',
    display: 'Standby13Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'standby13Diff',
    display: 'Standby13Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'standby100Meter',
    display: 'Standby100Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'standby100Diff',
    display: 'Standby100Diff',
    isFiltered: true,
  }),
] */

// const IfSwbdOnsUSHeaders = [
//   numCol({ ident: 'transhour', display: 'Transhour', isKey: true }),
//   strCol({ ident: 'unitNet', display: 'UnitNet', isFiltered: true }),
//   strCol({
//     ident: 'grossMwhMeter',
//     display: 'GrossMwhMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'grossMwhDiff', display: 'GrossMwhDiff', isFiltered: true }),
//   strCol({
//     ident: 'auxTransTMeter',
//     display: 'AuxTransTMeter',
//     isFiltered: true,
//   }),
//   strCol({
//     ident: 'auxTransTDiff',
//     display: 'AuxTransTDiff',
//     isFiltered: true,
//   }),
//   strCol({
//     ident: 'suTransCtMeter',
//     display: 'SuTransCtMeter',
//     isFiltered: true,
//   }),
//   strCol({
//     ident: 'suTransCtDiff',
//     display: 'SuTransCtDiff',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'fiveTMeter', display: 'FiveTMeter', isFiltered: true }),
//   strCol({ ident: 'fiveTDiff', display: 'FiveTDiff', isFiltered: true }),
//   strCol({ ident: 'fourTMeter', display: 'FourTMeter', isFiltered: true }),
//   strCol({ ident: 'fourTDiff', display: 'FourTDiff', isFiltered: true }),
//   strCol({ ident: 'ssfdMeter', display: 'SsfdMeter', isFiltered: true }),
//   strCol({ ident: 'ssfdDiff', display: 'SsfdDiff', isFiltered: true }),
//   strCol({ ident: 'totalGross', display: 'TotalGross', isFiltered: true }),
//   strCol({ ident: 'station', display: 'Station', isKey: true }),
//   strCol({ ident: 'unit', display: 'Unit', isKey: true }),
//   dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
//   strCol({ ident: 'stationNet', display: 'StationNet', isFiltered: true }),
//   strCol({
//     ident: 'standby13Meter',
//     display: 'Standby13Meter',
//     isFiltered: true,
//   }),
//   strCol({
//     ident: 'standby13Diff',
//     display: 'Standby13Diff',
//     isFiltered: true,
//   }),
//   strCol({
//     ident: 'standby100Meter',
//     display: 'Standby100Meter',
//     isFiltered: true,
//   }),
//   strCol({
//     ident: 'standby100Diff',
//     display: 'Standby100Diff',
//     isFiltered: true,
//   }),
// ]
